var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-h1"},[_c('h1',[_vm._t("default")],2),_c('div',{staticClass:"ed-h1__line"})])}
var staticRenderFns = []

export { render, staticRenderFns }